import type { Transition } from 'motion/react'

export const BASE_WIDGET_WIDTH = 400
export const BASE_WIDGET_HEIGHT = 210

export const DEFAULT_CONTAINER_SIZE = {
  width: BASE_WIDGET_WIDTH,
  height: BASE_WIDGET_HEIGHT
}

export const SMALL_VIEW_BREAKPOINT = 360
export const SMALL_VIEW_TOP_OFFSET = -15
export const DEFAULT_TOP_OFFSET = 5

export const HOVER_OFFSET_X_LEFT = -8
export const HOVER_OFFSET_X_RIGHT = 8
export const HOVER_OFFSET_Y = -5

export const ANIMATION_FRAME_DELAY = 3

export const SPRING_TRANSITION: Transition = {
  type: 'spring',
  damping: 90,
  stiffness: 700
}

export const ONBOARDING_WIDGET_CARD_LABELS = [
  {
    text: 'Time',
    basePosition: { top: 75, left: 60 },
    rotation: 9.4,
    className: ''
  },
  {
    text: 'Tasks',
    basePosition: { top: 95, left: 110 },
    rotation: 3.93,
    className: ''
  },
  {
    text: 'Files',
    basePosition: { top: 133, left: 180 },
    rotation: 2.7,
    className: 'files'
  },
  {
    text: 'Day',
    basePosition: { top: 95, left: 255 },
    rotation: -2.62,
    className: ''
  },
  {
    text: 'Absence',
    basePosition: { top: 80, left: 310 },
    rotation: -4.82,
    className: ''
  }
] as const
